exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-575d7978] .el-dialog__header {\n  text-align: center;\n}\n.submit-btn[data-v-575d7978] {\n  width: 140px;\n  height: 40px;\n  margin-left: 55px;\n  margin-top: 30px;\n  border-radius: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-575d7978","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/train/videoDetail/answerResultDialog.vue
// module id = 1577
// module chunks = 0